<template>
  <div class="col-md-2" style="background-color: var(--gh-color-darker); min-height: 100vh; padding: 1.5rem; border-right: 1px solid var(--gh-border);">
    <h5 class="mb-4 text-primary">{{ $t('panel.sidebar.title') }}</h5>
    <ul class="nav flex-column">
      <li class="nav-item" v-for="item in items" :key="item.id">
        <button
            class="btn btn-link text-start text-decoration-none text-light w-100 d-flex align-items-center justify-content-start gap-2"
            :class="{ 'fw-bold text-primary': current === item.id }"
            @click="navigate(item.id)"
        >
          <i :class="item.icon"></i>
          <span>{{ $t('panel.sidebar.items.' + item.id) }}</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'

const items = [
  { id: 'dashboard', label: 'Dashboard', icon: 'fas fa-chart-line' },
  { id: 'staff', label: 'Staff', icon: 'fas fa-user-tie' },
  { id: 'tickets', label: 'Tickets', icon: 'fas fa-ticket-alt' },
  { id: 'users', label: 'Users', icon: 'fas fa-users' },
  { id: 'tokens', label: 'Tokens', icon: 'fas fa-key' },
  { id: 'config', label: 'Config', icon: 'fas fa-cog' },
  { id: 'penalty-blocks', label: 'Penalty Blocks', icon: 'fas fa-gavel' },
  { id: 'report-settings', label: 'Report Settings', icon: 'fas fa-sliders-h' },
  { id: 'classifier', label: 'Classifier', icon: 'fas fa-tags' },
  { id: 'incidents', label: 'Incidents', icon: 'fas fa-exclamation-circle' }
]

const current = ref('dashboard')
const router = useRouter()

const navigate = (section) => {
  if (section === 'incidents') {
    router.push('/admin/incidents')
  } else {
    router.push({ path: '/panel', hash: `#${section}` })
  }
  current.value = section
}

onMounted(() => {
  const syncCurrent = () => {
    if (window.location.pathname.startsWith('/admin/incidents')) {
      current.value = 'incidents'
      return
    }
    const hash = window.location.hash.replace('#', '')
    current.value = items.some(i => i.id === hash) ? hash : 'dashboard'
  }
  syncCurrent()
  window.addEventListener('hashchange', syncCurrent)
  window.addEventListener('popstate', syncCurrent)
})
</script>
